import React from 'react'

const Title = () => {
    return(
        <div className = 'title'>
           <h1> PhotoGram </h1>
           <h2> Your showcase of photos </h2>
           <p> Share your photos with everyone 😍 </p>
        </div>
    )
}

export default Title;
